import styled from "styled-components";

const Container = styled.div`
  height: auto;
  min-height: 94vh;
  background-color: #fff;
  padding: 1px;
`;

const NoDataContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
`;

export { Container, NoDataContainer };
